import Splide from '@splidejs/splide';

export default function() {
	var splideContainers = document.querySelectorAll('.stats-carousel');
	if (!splideContainers) {
		return;
	}
	splideContainers.forEach(function(splideContainer) {
	let splide = new Splide( splideContainer, {
		// direction: 'ttb',
		height   : '12rem',
		arrows: false,
		pagination: 'splide__pagination stats-pagination',
		direction: 'ttb',
		autoplay: true,
		interval: 5000,
		breakpoints: {
			1000: {
				height: '14rem'
			},
			768: {
				direction: 'ltr',
				height: '11rem'
			},
			600: {
				height: '11rem'
			},
			550: {
				height: '11rem'
			},
			500: {
				height: '13rem'
			},
			375: {
				height: '14.5rem'
			}
		}
	} );
	splide.mount();
	});
}